define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    function parseMatrix(t) {
        if (t.indexOf('matrix(') === 0) {
            var ns = t.substr(7, t.length - 8).split(',');
            var result = [];
            for (var i = 0; i < ns.length; i++) {
                result.push(parseFloat(ns[i]));
            }
            return result;
        }
        return null;
    }
    function getOffsetX($cur) {
        var prev = $cur.css("transform");
        var mat = parseMatrix(prev);
        return mat[4];
    }
    function slide(dx, width, $viewport) {
        var prevX = getOffsetX($viewport);
        var tx = prevX + dx;
        var lastTile = $viewport.children().last()[0];
        var rightMost = lastTile.offsetLeft + width + tx;
        var result = false;
        if (tx <= 0 && rightMost - $viewport.width() >= 0) {
            result = true;
            $viewport.css({ 'transform': "translate(" + tx + "px)" });
        }
        return result;
    }
    function slideLeft(width, $viewport) {
        $viewport.toggleClass('animating', true);
        var prev = getOffsetX($viewport);
        var cur = Math.round(prev / width);
        var dx = (cur - 1) * width - prev;
        if (slide(dx, width, $viewport)) {
            setPagingIndex($viewport.next('.paging'), Math.abs(cur) + 1);
        }
    }
    function slideRight(width, $viewport) {
        $viewport.toggleClass('animating', true);
        var prev = getOffsetX($viewport);
        var cur = Math.round(prev / width);
        var dx = (cur + 1) * width - prev;
        var index = Math.abs;
        if (slide(dx, width, $viewport)) {
            setPagingIndex($viewport.next('.paging'), Math.abs(cur) - 1);
        }
    }
    function asPointerEvent(e) {
        if (e instanceof MouseEvent) {
            return { event: e, clientX: e.clientX, clientY: e.clientY };
        }
        if (e instanceof TouchEvent) {
            var touch = e.touches.length ? e.touches[0] : e.changedTouches[0];
            return { clientX: touch.clientX, clientY: touch.clientY, event: e };
        }
    }
    function setPagingIndex($p, index) {
        $p.find('.dot.current').toggleClass('current', false);
        $($p.find('.dot')[index]).toggleClass('current', true);
    }
    function getPagingIndex($p) {
        return $p.find('.dot').index($p.find('.dot.current')[0]);
    }
    function clickPagingDot(width, $vp, $p, $dot, snap) {
        if (!$dot.hasClass('current')) {
            $p.find('.dot.current').toggleClass('current', false);
            $dot.toggleClass('current', true);
            if (!snap) {
                $vp.toggleClass('animating');
            }
            $vp.css({ transform: "translate(" + getPagingIndex($p) * -width + "px)" });
        }
    }
    function computePagingIndex(width, $viewport) {
        var prev = getOffsetX($viewport);
        return Math.round(prev / -width);
    }
    function autoPlay($viewport, interval) {
        return setInterval(function () {
            var $dot = $viewport.find('.paging .dot.current');
            if ($dot.index() == $viewport.find('.paging .dot').length - 1) {
                $viewport.find('.paging .dot:first-child').click();
            }
            else {
                $viewport.find('.flipper-right').click();
            }
        }, interval);
    }
    function stopAutoPlay($viewport) {
        var interval = $viewport.data('autoPlayInterval');
        if (interval) {
            clearInterval(interval);
            $viewport.removeData('autoPlayInterval');
        }
    }
    (function ($) {
        $.fn.carousel = function (width, autoPlayInterval) {
            var $all = this;
            $all.each(function (i, c) {
                var $cur = $(c);
                var swipeHandler = function (x) {
                    var e = asPointerEvent(x);
                    if (e.event instanceof MouseEvent) {
                        e.event.preventDefault();
                        e.event.stopPropagation();
                    }
                    $cur.data('dragStart', { x: e.clientX, y: e.clientY });
                    stopAutoPlay($cur);
                    var moveHandler = function (x) {
                        var e = asPointerEvent(x);
                        var start = $cur.data('dragPrev') || $cur.data('dragStart');
                        if (!start) {
                            return;
                        }
                        var dx = e.clientX - start.x;
                        var dy = e.clientY - start.y;
                        if (Math.abs(dy) > Math.abs(dx)) {
                            return;
                        }
                        if (Math.abs(dx) > 5) {
                            $cur.data('dragPrev', { x: e.clientX, y: e.clientY });
                            slide(dx, width, $cur.find('.section-viewport'));
                        }
                    };
                    c.addEventListener('mousemove', moveHandler, true);
                    c.addEventListener('touchmove', moveHandler, true);
                    var upHandler = function (x) {
                        var e = asPointerEvent(x);
                        if (e.event instanceof MouseEvent) {
                            e.event.preventDefault();
                            e.event.stopPropagation();
                        }
                        var start = $cur.data('dragStart');
                        if (start) {
                            var dx = e.clientX - start.x;
                            var dy = e.clientY - start.y;
                            console.log("mouseup {" + e.clientX + ", " + e.clientY + "}");
                            if (Math.abs(dx) >= 30 && Math.abs(dy / dx) < 0.3) {
                                var $vp = $cur.find('.section-viewport');
                                if (dx < 0) {
                                    slideLeft(width, $vp);
                                }
                                else {
                                    slideRight(width, $vp);
                                }
                                var trap_1 = function (e) {
                                    e.stopPropagation();
                                    c.removeEventListener('click', trap_1, true);
                                };
                                c.addEventListener('click', trap_1, true);
                            }
                            $cur.removeData('dragStart').removeData('dragPrev');
                            c.removeEventListener('mousemove', moveHandler, true);
                            c.removeEventListener('touchmove', moveHandler, true);
                            c.removeEventListener('touchend', upHandler, true);
                            c.removeEventListener('mouseup', upHandler, true);
                        }
                    };
                    c.addEventListener('touchend', upHandler, true);
                    c.addEventListener('mouseup', upHandler, true);
                };
                c.addEventListener('touchstart', swipeHandler, true);
                c.addEventListener('mousedown', swipeHandler, true);
                if (autoPlayInterval) {
                    var interval = autoPlay($cur, autoPlayInterval);
                    $cur.data('autoPlayInterval', interval);
                }
                var $viewport = $cur.find('.section-viewport');
                $cur.find('.paging .dot').click(function (e) {
                    e.preventDefault();
                    if (!e.isTrigger) {
                        stopAutoPlay($cur);
                    }
                    clickPagingDot(width, $viewport, $viewport.next('.paging'), $(e.target), e.isTrigger);
                });
                $viewport[0].addEventListener('transitionend', function (e) {
                    $viewport.toggleClass('animating', false);
                }, false);
                $cur.find('.flipper-left, .flipper-right').click(function (e) {
                    var goLeft = !$(e.target).hasClass('flipper-left');
                    if (!e.isTrigger) {
                        stopAutoPlay($cur);
                    }
                    if (goLeft) {
                        slideLeft(width, $viewport);
                    }
                    else {
                        slideRight(width, $viewport);
                    }
                });
            });
        };
    })($);
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/jquery-plugins/carousel.js
// module id = 20
// module chunks = 0